import { useEffect } from 'react';
import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import cameraDisconnectedIcon from 'src/assets/icons/camera-disconnected.svg';

import SmallModalTemplate from 'src/components/SmallModalTemplate';

import useCheckCameraConnection from 'src/hooks/useCheckCameraConnection';

type WarnNoConnectedCameraModalProps = {
  isVisible: boolean;
  onClose: () => void;
};

export default function WarnNoConnectedCameraModal({
  isVisible,
  onClose,
}: WarnNoConnectedCameraModalProps) {
  const history = useHistory();

  const gotoSettings = () => {
    history.push('/settings');
  };

  const { t } = useTranslation();

  const { canStartExam } = useCheckCameraConnection();

  const hasRecovered = isVisible && canStartExam;

  useEffect(() => {
    if (hasRecovered) {
      onClose();
    }
  }, [hasRecovered, onClose]);

  return (
    <SmallModalTemplate
      show={isVisible && !hasRecovered}
      onHide={onClose}
      data-test="camera-not-connected-modal"
      backdropClassName="connection-issue-backdrop"
      style={{ zIndex: 2000 }}
      iconWrapperClassName="bg-danger-100"
      icon={
        <img
          src={cameraDisconnectedIcon}
          alt={t('newExam.noCameraConnected.title')}
        />
      }
      title={t('newExam.noCameraConnected.title')}
      description={t('newExam.noCameraConnected.desc')}
      leftButton={
        <Button
          variant="outline-gray-400"
          className="clear-exam-button"
          onClick={onClose}
          data-test="no-camera-close"
        >
          {t('newExam.noCameraConnected.close')}
        </Button>
      }
      rightButton={
        <Button
          variant="primary"
          onClick={gotoSettings}
          data-test="no-camera-go-to-settings"
          data-track="camera.no-camera-modal.go-to-settings"
          data-observe
        >
          {t('newExam.noCameraConnected.buttonText')}
        </Button>
      }
    />
  );
}
